import type { AccountType } from 'eve-account-client';

export type AccessMethodFormData = {
  type: AccountType;
  webServiceAccess: boolean;
};

export enum AccessMethodType {
  EMPLOYER = 'EMPLOYER',
  AGENCY = 'AGENCY',
  EMPLOYER_WS = 'EMPLOYER_WS',
  AGENCY_WS = 'AGENCY_WS',
  CORPORATE = 'CORPORATE',

  CHILD = 'CHILD',
  CHILD_WS = 'CHILD_WS',
}
